import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("<BannersContainer />\n\n{{yield}}\n",{ moduleName: "client-portal/components/site-content.hbs" })